import { component as defineComponent } from 'flightjs';
import {debounce} from 'lodash';

var accordion = function () {
    this.after('initialize', function () {
        this.$accordion = this.$node;
        this.$items = this.$accordion.children('[data-accordion-item]');
        this.$triggers = this.$items.children('[data-accordion-item-trigger]');
        this.collapsedHeight = $(this.$triggers.children('[data-accordion-item-body]')[0]).innerHeight();
        this.calculateHeights();

        // Toggle accordion items on trigger click
        this.$triggers.on('click', function(e) {
            if (e.target.tagName !== 'A') {
                this.toggleItem($(e.delegateTarget));
            }
        }.bind(this));

        // React to child element height changes (e.g. nested accordions)
        this.$accordion.on('uiAccordionChildItemCollapsed', this.handleChildItemCollapse.bind(this));

        // Re-calculate heights when brower size changes
        $(window).on('resize', debounce(this.calculateHeights.bind(this), 300));
    });

    this.toggleItem = function (el) {
        var $body = $(el).children('[data-accordion-item-body]');
        var $item = $(el).closest('[data-accordion-item]');
        var bodyHeight = $body.data('height');
        var $wrapperAccordion = this.$accordion.parent().closest('[data-accordion]');

        if ($item.attr('data-active') !== 'true') {
            $body.css({
                minHeight: bodyHeight
            });

            $item.attr('data-active', true);

            // Move to min-height after transition to react to child element
            // height changes
            setTimeout(function () {
                if ($item.attr('data-active') === 'true') {
                    $body.css({
                        height: 'auto',
                        minHeight: bodyHeight
                    });
                }
            }.bind(this), 500);
        } else {
            $body.data('height', $body.innerHeight());

            $body.css({
                height: this.collapsedHeight,
                minHeight: 0
            });

            $item.removeAttr('data-active');
            $wrapperAccordion.trigger('uiAccordionChildItemCollapsed');
        }
    };

    this.calculateHeights = function () {
        this.$triggers.children('[data-accordion-item-body]').each(function (idx, el) {
            var $el = $(el);
            var isActive = $el.closest('[data-accordion-item]').attr('data-active') === 'true';

            // Prepare element for height calculation
            $el.attr('data-active', true);
            $el.css({height: 'auto'});

            // Set original-height only if not set for later re-use
            if (!$el.data('oiginal-height')) {
                $el.data('oiginal-height', $el.innerHeight());
            }

            // Update height to store updated height
            $el.data('height', $el.innerHeight());

            // Reset element after height calculation
            $el.removeAttr('data-active');
            if (isActive) {
                $el.css({
                    height: 'auto',
                    minHeight: $el.innerHeight()
                });
            } else {
                $el.css({height: this.collapsedHeight});
            }
        }.bind(this));
    };

    this.handleChildItemCollapse = function () {
        this.$items.children('[data-accordion-item-body]').each(function (idx, el) {
            var $el = $(el);

            $el.css({
                height: 'auto',
                minHeight: $(el).data('oiginal-height') || $el.data('height')
            });
        }.bind(this));
    };
};

export default defineComponent(accordion);



// WEBPACK FOOTER //
// ./src/web/js/marketing/ui/accordion.js